import React, { useEffect, useState } from "react";
import HomeTourPackagesSection from "./HomeTourPackagesSection";
import { getPopularPackages } from "../../actions/tour/tourAction";

function PopularPackages({ onOpenPackage }) {
    const [packages, setPackages] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getPopularPackages((data) => {
            setPackages(data || []);
            setLoading(false);
        });
    }, []);

    if (loading) {
        return (
            <section className="w-full py-6">
                <div className="max-w-6xl mx-auto px-4 space-y-3">
                    <div className="flex items-end justify-between gap-2">
                        <div className="space-y-1">
                            <p className="text-[11px] uppercase tracking-[0.18em] text-muted-foreground">
                                Popular tour packages
                            </p>
                            <h2 className="text-lg md:text-xl font-semibold tracking-tight">
                                Popular tour packages
                            </h2>
                        </div>
                    </div>
                    <div className="grid gap-3 sm:gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
                        <div className="h-[400px] w-full bg-gray-200 animate-pulse rounded-lg"></div>
                        <div className="h-[400px] w-full bg-gray-200 animate-pulse rounded-lg"></div>
                        <div className="h-[400px] w-full bg-gray-200 animate-pulse rounded-lg"></div>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <HomeTourPackagesSection
            title="Popular tour packages"
            packages={packages}
            onOpenPackage={onOpenPackage}
        />
    );
}

export default PopularPackages;
